export const gradeLevels = [
  // {
  //   value: "T",
  //   label: "Toddler",
  //   alt: "T",
  //   subjects: "preschool",
  //   sort: 1,
  // },
  // {
  //   value: "N",
  //   label: "Nursery",
  //   alt: "N",
  //   subjects: "preschool",
  //   sort: 1,
  // },
  // { value: "K1", label: "Kinder 1", alt: "K1", subjects: "preschool", sort: 2 },
  // { value: "K2", label: "Kinder 2", alt: "K2", subjects: "preschool", sort: 3 },
  { value: "K", label: "Kinder", alt: "K", subjects: "preschool", sort: 1 },
  { value: "G1", label: "Grade 1", alt: "1", subjects: "elementary", sort: 2 },
  { value: "G2", label: "Grade 2", alt: "2", subjects: "elementary", sort: 3 },
  { value: "G3", label: "Grade 3", alt: "3", subjects: "elementary", sort: 4 },
  { value: "G4", label: "Grade 4", alt: "4", subjects: "elementary", sort: 5 },
  { value: "G5", label: "Grade 5", alt: "5", subjects: "elementary", sort: 6 },
  { value: "G6", label: "Grade 6", alt: "6", subjects: "elementary", sort: 7 },
  { value: "G7", label: "Grade 7", alt: "7", subjects: "juniorHigh", sort: 8 },
  { value: "G8", label: "Grade 8", alt: "8", subjects: "juniorHigh", sort: 9 },
  { value: "G9", label: "Grade 9", alt: "9", subjects: "juniorHigh", sort: 10 },
  {
    value: "G10",
    label: "Grade 10",
    alt: "10",
    subjects: "juniorHigh",
    sort: 11,
  },
  {
    value: "G11",
    label: "Grade 11",
    alt: "11",
    subjects: "seniorHigh",
    sort: 12,
  },
  {
    value: "G12",
    label: "Grade 12",
    alt: "12",
    subjects: "seniorHigh",
    sort: 13,
  },
];
